import "../styles/adContainers.css";
import "../styles/feedPostMedia.css";
import "../Wlj/assets/css/fontawesome.css";
import "../Wlj/assets/css/header.css";
import "../Wlj/assets/css/navigation.css";
import "../Wlj/assets/css/PersonalProfile.css";
import "../Wlj/assets/css/newsFeed.css";
import "../Wlj/assets/css/toggle.css";
import "../Wlj/assets/css/AboutUs.css";
import "../Wlj/assets/css/Articles.css";
import "../Wlj/assets/css/Business.css";
import "../Wlj/assets/css/Blogs.css";
import "../Wlj/assets/css/connection.css";
import "../Wlj/assets/css/Editors.css";
import "../Wlj/assets/css/HelpCenter.css";
import "../Wlj/assets/css/History.css";
import "../Wlj/assets/css/JobNotification.css";
import "../Wlj/assets/css/JobSearch.css";
import "../Wlj/assets/css/ManageResume.css";
import "../Wlj/assets/css/Message.css";
import "../Wlj/assets/css/notification.css";
import "../Wlj/assets/css/people.css";
import "../Wlj/assets/css/Post.css";
import "../Wlj/assets/css/PrivacyPolicy.css";
import "../Wlj/assets/css/ResumeDesign.css";
import "../Wlj/assets/css/setting.css";
import "../Wlj/assets/css/SignIn.css";
import "../Wlj/assets/css/userAuth.css";
import "../Wlj/assets/css/ViewResume.css";

const LOCAL_STYLE_PREFIX = "/cdn/assets/css/";

const loadedStylesheets = new Set();

/** Kept for callers that previously injected CDN <link> tags. Styles are bundled locally. */
export const loadAppStylesheet = (fileName) => {
  const normalized = String(fileName || "").replace(/^css\//, "");
  const href = `${LOCAL_STYLE_PREFIX}${normalized}`;
  loadedStylesheets.add(href);
  return href;
};

const injectAdThemeOverrides = () => {
  if (document.getElementById("wlj-ad-theme-overrides")) {
    return;
  }

  const style = document.createElement("style");
  style.id = "wlj-ad-theme-overrides";
  style.textContent = `
    html[data-theme="dark"] .advertiseImage,
    html[data-theme="dark"] .advertisementview,
    html[data-theme="dark"] .advertisementContainer,
    html[data-theme="dark"] .ad-container,
    html[data-theme="dark"] .Adwrapper,
    html[data-theme="dark"] .AdwrapperwithText,
    html[data-theme="dark"] .ad-wrapper,
    body.darkMode .advertiseImage,
    body.darkMode .advertisementview,
    body.darkMode .advertisementContainer,
    body.darkMode .ad-container,
    body.darkMode .Adwrapper,
    body.darkMode .AdwrapperwithText,
    body.darkMode .ad-wrapper {
      background-color: var(--ad-container-bg, #1c1c24) !important;
      border-color: var(--ad-container-border, #3c3b3d) !important;
    }

    html[data-theme="dark"] ins.adsbygoogle:not([data-adsbygoogle-status="done"]),
    body.darkMode ins.adsbygoogle:not([data-adsbygoogle-status="done"]) {
      background-color: var(--ad-container-bg, #1c1c24) !important;
    }

    html[data-theme="dark"] .adText,
    body.darkMode .adText {
      color: var(--text-color, #b5b5be) !important;
    }
  `;
  document.head.appendChild(style);
};

injectAdThemeOverrides();
